export var ENewsFeedOwner;
(function (ENewsFeedOwner) {
    ENewsFeedOwner["USER"] = "USER";
    ENewsFeedOwner["ASSET"] = "ASSET";
})(ENewsFeedOwner || (ENewsFeedOwner = {}));
